import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from './../../../environments/environment';
import { OpeningHour } from './../../../_models/opening-hour';

@Injectable({
  providedIn: 'root',
})
export class OpeningHoursService {
  openingHoursUrl = environment.apiUrl + '/opening_hours';

  constructor(private http: HttpClient) {}

  getOpeningHours(): Observable<OpeningHour[]> {
    return this.http
      .get<OpeningHour[]>(this.openingHoursUrl)
      .pipe(
        map((openingHours) =>
          openingHours.sort((a, b) => (a.order - b.order > 0 ? 1 : -1))
        )
      );
  }
}
